import { Pagination } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAppointmentHistory,
  fetchSelectedAppointmentDetails,
} from "../../actions/AppointmentActions";
import { fetchDoctorAppointmentHistory } from "../../actions/DoctorAppointmentActions";
import CustomeModal from "../CustomeModal/CustomeModal";
import "./appointmenthistory.css";
//import DoctorAppointmentHistoryModalContent from './AppointmentHistoryModalContent/DoctorAppointmentHistoryModalContent'
import DoctorAppointmentHistoryModalContent from "./AppointmentHistoryModalContent/DoctorAppointmentHistoryModalContent";
import Spinner from "react-bootstrap/Spinner";
import { fetch_clientDetails } from "../../actions/MicrositeAction";

function DoctorAppoinmentHistory({
  white,
  goToPrescription,
  goToCreatePrescription,
}) {
  let [modal, setModal] = useState(false);
  let [totalnoofpages, setTotalnoofpages] = useState(0);
  let [activePage, setActivePage] = useState(1);
  let dispatch = useDispatch();
  let reduxData = useSelector((state) => state);
  let [appointmentHistoryRedux, setappointmentHistoryRedux] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isMoreLoading, setIsMoreLoading] = useState(true);
  const [favicon, setFavicon] = useState(null);

  // const appointmentHistoryRedux = reduxData.doctorAppointmentHistory.doctorAppointmentHistory ?
  //reduxData.doctorAppointmentHistory.doctorAppointmentHistory : null;
  const userData = useSelector((state) => state.login.user);

  const doctorData = useSelector((state) => state.login.doctorDashboard);

  let handleTableClick = (appointmentId) => {
    setIsMoreLoading(true); // Set loading to true before dispatching the action
    setModal(true);
    // setSelectedappointmentId(appointmentId)
    // Dispatch the action
    dispatch(
      fetchSelectedAppointmentDetails({
        appointmentId: appointmentId ? appointmentId : null,
        userData,
      })
    ).then(() => {
      // This code block will be executed after the action is completed
      setIsMoreLoading(false); // Set loading to false after the action is completed
    });
  };

  const fetchClientDetails = async (clinicId) => {
    try {
      const response = await dispatch(fetch_clientDetails("gericare"));
      console.log("Client Details API Response:", response); // Log the entire response
      console.log('favicon', response.favicon)
      setFavicon(response.favicon)
      if (response && response.data) {
        console.log("Client Details:", response.data); // Log the client details
      } else {
        console.log("No client details found in the response");
      }

      return response && response.data ? response.data : null;
    } catch (error) {
      console.error("Error fetching client details:", error);
      return null;
    }
  };
  console.log('favicon',favicon)
  useEffect(() => {
    dispatch(fetchDoctorAppointmentHistory(userData?.profileId, "0")).then(
      (res) => {
        console.log("res", res);
        if (res?.totalNumberOfPages != undefined) {
          //   totalnoofpages=res.data.data.totalNumberOfPages;
          setTotalnoofpages(res?.totalNumberOfPages);
        }
        setLoading(false);
        setappointmentHistoryRedux(res?.appointmentHistory);
      }
    );
    fetchClientDetails();
  }, []);

  let handlePaginationChange = (e) => {
    setActivePage(e);
    // setLoader(true)
    dispatch(fetchDoctorAppointmentHistory(userData?.profileId, e - 1)).then(
      (res) => {
        console.log(
          "**************fetchAppointmentHistory API result ==> ",
          res
        );
        // setLoader(false)
        setappointmentHistoryRedux(res?.appointmentHistory);
      }
    );
  };
  let getDateFull = () => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Friday", "Saturday"];

    let today = new Date();

    let date = today.getDate();
    let month = today.getMonth();
    let year = today.getFullYear();
    let week = today.getDay();
    console.log();
    return `${date}, ${months[month]}, ${year} - ${days[week]}`;
  };

  return (
    <>
      <div
        className={`appontment-history-container ${
          white ? "appontment-history-container-white" : ""
        }`}
      >
        {/* <div className="header"> */}
        {/* {getDateFull()} */}

        {/* <div className="filter-button">
                    <div className="icon">&nbsp;</div>
                    Filter Appointments
                </div> */}
        {/* </div> */}
        <div className="appoinment-table-wrap">
          {isLoading ? (
            <div className="loader">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : appointmentHistoryRedux && appointmentHistoryRedux?.length > 0 ? (
            <table className="appoinment-table">
              <tr>
                <th>Appointment ID</th>
                <th>Appointment Date & Time</th>
                <th>Patient Name</th>
                <th>Consultation Status</th>
                {/* <th>Next Steps</th> */}
                <th></th>
              </tr>
              <tbody>
                {
                  //  appointmentHistoryRedux.length>0 ?
                  appointmentHistoryRedux != null ? (
                    appointmentHistoryRedux.map((element, key) => {
                      return (
                        <tr>
                          <td>{element.appointmentId}</td>
                          <td>{element.appointmentDate}</td>
                          <td>{element.consultantName}</td>
                          <td>{element.appointmentStatus}</td>
                          {/* <td >
                                                    Not Available
                                                </td> */}
                          <td>
                            <button
                              onClick={() => {
                                handleTableClick(element.appointmentId);
                              }}
                              className="more-btn"
                            >
                              More
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <div className="no-appointments">
                      Oops!! There is no appointment available for you.
                    </div>
                  )
                }
              </tbody>
            </table>
          ) : (
            <div className="no-appointments">
              Oops!! There is no appointment available for you.
            </div>
          )}
        </div>
        <div className="pagination-container">
          <Pagination
            showSizeChanger={false}
            onChange={handlePaginationChange}
            defaultCurrent={activePage}
            total={totalnoofpages * 10}
          />
        </div>
      </div>

      <CustomeModal
        state={modal}
        setModal={setModal}
        component={
          <DoctorAppointmentHistoryModalContent
            goToPrescription={goToPrescription}
            goToCreatePrescription={goToCreatePrescription}
            isMoreLoading={isMoreLoading}
            favicon={favicon}
          />
        }
        isRight
      />
    </>
  );
}
export default DoctorAppoinmentHistory;
